import isofetch from 'isomorphic-fetch';

export async function fetch(url, body, method = 'POST', { responseType = 'json' } = {}) {
  const headers = {
    'Request-Source': 'ajax',
  };

  if (body) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await isofetch(url, {
    credentials: 'include',
    method,
    body: body ? JSON.stringify(body) : undefined,
    headers,
  });
  const data = await response[responseType]();
  return {
    req: { url, body, method },
    res: response,
    status: response.status,
    body: data,
  };
}
